<template>
  <div>
    <!--v-btn text icon>
            <v-icon>language</v-icon>
        </!--v-btn-->

    <!--v-select v-model="selectedLanguage" hide-details transition="slide-y-reverse-transition" label="Select Language" overflow
            @change="setLocale()" item-text="text" item-value="value" :items="languages"></v-select-->
    <div v-if="loginPage==true">


          <template>
            <div class="text-center">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn style="font-size:1.4rem"  left icon v-bind="attrs" v-on="on" fab dark>
                    <!--v-icon color="white">language</!--v-icon-->
                    {{getPreferredLanguage}}
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-for="child in languages" :key="child.text" child.text @change="setLocale(child.value)">
                    <v-list-item-content >
                      <v-list-item-title style="padding: 0 16px;margin-left:6%;"
                        v-bind:class="(getPreferredLanguage==child.value)?'activeLanguage':''">
                        {{child.text}}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

    </div>
    <div v-else>
      <v-list-group>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title style="padding: 0 16px" class="text-uppercase .v-size--default" v-text="'Language'">
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="child in languages" :key="child.text" child.text @change="setLocale(child.value)">
          <v-list-item-content>
            <v-list-item-title style="padding: 0 16px;margin-left:6%"
              v-bind:class="(getPreferredLanguage==child.value)?'activeLanguage':''">
              {{child.text}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </div>

  </div>
</template>
<script>

export default {
    name: 'changeLanguageBtn',
    components: {
    },
    props: {
        loginPage: {
            type: Boolean,
            required: false
      }
    },
    data () {
        return {
            languages:[{text:'Italian',value:'it'},{text:'English',value:'en'},{text:'Catalán',value:'cat'},{text:'Spanish',value:'es'},{text:'Português',value:'pt'},{text:'Français',value:'fr'}],
            selectedLanguage:""
        }
    },

//non serve questo mounted
//metto una computed che legge dallo store e un watch che legge dalle lingue dentro app e mantiene la lingua allineata con quello che c'è nello store

    mounted(){
        this.selectedLanguage = this.getPreferredLanguage
        this.$vuetify.lang.current = this.getPreferredLanguage
        this.$i18n.locale = this.getPreferredLanguage;

  },
    computed: {
        getPreferredLanguage: {
            get: function () {
                return this.$store.getters.getPreferredLanguage;
            }
        }
    },
    methods: {
    setLocale(value) {
        this.$store.dispatch("setPreferredLanguage", value)
        this.$i18n.locale = this.getPreferredLanguage;
        this.$vuetify.lang.current = this.getPreferredLanguage;
              this.$store.dispatch("setIsdrawerOpen", false)

    }
    }
};
</script>

<style>
.v-list-item__title{
  font-size:0.875rem!important;
}
.activeLanguage{
  font-weight: bold;
  color:#38737A!important; 
  text-decoration: underline;
  text-decoration-color:#38737A;
}
.v-list-item{
margin-left:0px;
padding-left: 0px;
}

.v-menu__content{
right: 0px;
}
</style>